// src/store/ducks/compare.ts
import { createSlice } from "@reduxjs/toolkit";
import { Product } from "../../models/app";

interface CompareState {
  items: Product[];
}

const initialState: CompareState = {
  items: [],
};

export const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
   toggleCompare(state, action) {
        const item = action.payload;
        const exists = state.items.find((x) => x.SystemId === item.SystemId);

        if (exists) {
          state.items = state.items.filter((x) => x.SystemId !== item.SystemId);
        } else {
          if (state.items.length < 4) {
            state.items.push({
              ...item,
              additionalServices: item.optionalServices ?? [], 
            });
          }
        }
      },

    removeFromCompare(state, action) {
      state.items = state.items.filter((x) => x.SystemId !== action.payload);
    },
    clearCompare(state) {
      state.items = [];
    },
  },
});

export const { toggleCompare, removeFromCompare, clearCompare } =
  compareSlice.actions;

export default compareSlice.reducer;
